var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { GOOGLE_AUTH_ACTION } from '@actions/actions/authentication/google-auth-action';
import { AuthMethodScope, ProviderType } from '@lit-protocol/constants';
import { LitContracts } from '@lit-protocol/contracts-sdk';
import { createDbCloudWallet } from '../db/DBCloudWalletHelpers';
import { fetchDBUser, createDBUser } from '../db/DBUserHelpers';
import IpfsHash from 'ipfs-only-hash';
import { ExtendedProviderType } from '@shared/types/lit-protocol';
import getGoogleInfo from './getGoogleInfo';
import { getUrls } from '@shared/utils/config/environment';
export var mintPKP = function (authType, authMethod, authProvider, connectedWalletAddress, setProgressBar) { return __awaiter(void 0, void 0, void 0, function () {
    var authMethodId_1, paramArrays, _a, permittedAuthMethodTypes, permittedAuthMethodIds, permittedAuthMethodScopes, permittedAuthMethodPubkeys, params, txHash, response, newPKP, userInfo, existingUser, userId, newUser, dbCloudWalletResult, addWalletToIndexer, err_1;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 14, , 15]);
                return [4 /*yield*/, authProvider.getAuthMethodId(authMethod)];
            case 1:
                authMethodId_1 = _d.sent();
                console.log('MINT INFO 1', { authMethod: authMethod, authMethodId: authMethodId_1 });
                paramArrays = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var permittedAuthMethodTypes, permittedAuthMethodIds, permittedAuthMethodScopes, permittedAuthMethodPubkeys, litContracts, litActionHash, litActionHashAsBytes;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                permittedAuthMethodTypes = [authMethod.authMethodType];
                                permittedAuthMethodIds = [authMethodId_1];
                                permittedAuthMethodScopes = [[AuthMethodScope.SignAnything]];
                                permittedAuthMethodPubkeys = ['0x'];
                                litContracts = new LitContracts();
                                if (!(authType == ProviderType.Google || authType == 'genius-google')) return [3 /*break*/, 2];
                                return [4 /*yield*/, IpfsHash.of(GOOGLE_AUTH_ACTION)];
                            case 1:
                                litActionHash = _a.sent();
                                litActionHashAsBytes = litContracts.utils.getBytesFromMultihash(litActionHash);
                                permittedAuthMethodTypes.push(2);
                                permittedAuthMethodIds.push(litActionHashAsBytes);
                                permittedAuthMethodPubkeys.push('0x');
                                permittedAuthMethodScopes.push([AuthMethodScope.SignAnything]);
                                _a.label = 2;
                            case 2: return [2 /*return*/, {
                                    permittedAuthMethodTypes: permittedAuthMethodTypes,
                                    permittedAuthMethodIds: permittedAuthMethodIds,
                                    permittedAuthMethodScopes: permittedAuthMethodScopes,
                                    permittedAuthMethodPubkeys: permittedAuthMethodPubkeys,
                                }];
                        }
                    });
                }); };
                return [4 /*yield*/, paramArrays()];
            case 2:
                _a = _d.sent(), permittedAuthMethodTypes = _a.permittedAuthMethodTypes, permittedAuthMethodIds = _a.permittedAuthMethodIds, permittedAuthMethodScopes = _a.permittedAuthMethodScopes, permittedAuthMethodPubkeys = _a.permittedAuthMethodPubkeys;
                setProgressBar && setProgressBar(function (prev) { return 20; });
                params = {
                    keyType: 2,
                    permittedAuthMethodTypes: permittedAuthMethodTypes,
                    permittedAuthMethodIds: permittedAuthMethodIds,
                    permittedAuthMethodScopes: permittedAuthMethodScopes,
                    permittedAuthMethodPubkeys: permittedAuthMethodPubkeys,
                    addPkpEthAddressAsPermittedAddress: true,
                    sendPkpToItself: true,
                };
                console.log('MINT INFO 2', params, 'params');
                return [4 /*yield*/, authProvider.mintPKPThroughRelayer(authMethod, params)];
            case 3:
                txHash = _d.sent();
                setProgressBar && setProgressBar(function (prev) { return 25; });
                console.log('MINTING TX HASH', txHash);
                return [4 /*yield*/, authProvider.relay.pollRequestUntilTerminalState(txHash)];
            case 4:
                response = _d.sent();
                setProgressBar && setProgressBar(function (prev) { return 30; });
                console.log('MINTING RESPONSE', response);
                if (response.status !== 'Succeeded') {
                    throw new Error('Minting failed');
                }
                newPKP = {
                    tokenId: response.pkpTokenId,
                    publicKey: response.pkpPublicKey,
                    ethAddress: response.pkpEthAddress,
                };
                console.log('MINT SUCCESS', newPKP);
                userInfo = void 0;
                if (!(authType === ExtendedProviderType.Google || authType == ExtendedProviderType.GoogleG)) return [3 /*break*/, 6];
                return [4 /*yield*/, getGoogleInfo({ accessToken: authMethod === null || authMethod === void 0 ? void 0 : authMethod.accessToken })];
            case 5:
                userInfo = _d.sent();
                _d.label = 6;
            case 6: return [4 /*yield*/, fetchDBUser({ creationAuthMethodId: authMethodId_1 })];
            case 7:
                existingUser = (_d.sent()).data;
                userId = null;
                if (!!(existingUser === null || existingUser === void 0 ? void 0 : existingUser.id)) return [3 /*break*/, 9];
                console.log('creating new user', authType, authMethodId_1);
                return [4 /*yield*/, createDBUser({
                        creation_auth_method: authType,
                        creation_auth_method_id: authMethodId_1,
                        wallet_address: connectedWalletAddress,
                        email: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email,
                        first_name: userInfo === null || userInfo === void 0 ? void 0 : userInfo.given_name,
                        last_name: userInfo === null || userInfo === void 0 ? void 0 : userInfo.family_name,
                    })];
            case 8:
                newUser = _d.sent();
                userId = (_b = newUser === null || newUser === void 0 ? void 0 : newUser.data) === null || _b === void 0 ? void 0 : _b.id;
                return [3 /*break*/, 10];
            case 9:
                userId = existingUser === null || existingUser === void 0 ? void 0 : existingUser.id;
                _d.label = 10;
            case 10: return [4 /*yield*/, createDbCloudWallet({
                    eth_address: newPKP === null || newPKP === void 0 ? void 0 : newPKP.ethAddress,
                    pkp: newPKP,
                    creation_auth_method: authType,
                    creation_auth_method_id: authMethodId_1,
                    lit_network: process.env.NEXT_PUBLIC_LIT_NETWORK,
                    user_id: userId,
                    creation_tx_hash: txHash,
                })];
            case 11:
                dbCloudWalletResult = _d.sent();
                setProgressBar && setProgressBar(function (prev) { return 35; });
                console.log('dbCloudWalletResult', dbCloudWalletResult);
                return [4 /*yield*/, fetch("".concat(getUrls().INDEXER_URL, "/portfolio/start-tracking?wallet=").concat(newPKP === null || newPKP === void 0 ? void 0 : newPKP.ethAddress))];
            case 12: return [4 /*yield*/, ((_c = (_d.sent())) === null || _c === void 0 ? void 0 : _c.json())];
            case 13:
                addWalletToIndexer = _d.sent();
                console.log('addToIndexer', addWalletToIndexer);
                return [2 /*return*/, newPKP];
            case 14:
                err_1 = _d.sent();
                console.log('ERROR in mintPKP: ', err_1);
                return [3 /*break*/, 15];
            case 15: return [2 /*return*/, null];
        }
    });
}); };
